import '../../styles/globals.css'

function Benefits(){
    return (
        <section className="features">
            <div className="container">
                <h2 className="section-title">Por que escolher a Hapvida?</h2>
                <div className="features-grid">
                    <div className="feature-card">
                        <div className="feature-icon">🏥</div>
                        <h3>Rede Própria</h3>
                        <p>Mais de 85 hospitais, 352 clínicas médicas e 77 prontos atendimentos em todo o Brasil.</p>
                    </div>
                    <div className="feature-card">
                        <div className="feature-icon">💰</div>
                        <h3>Preço Acessível</h3>
                        <p>Planos com excelente custo-benefício para todos os perfis e necessidades.</p>
                    </div>
                    <div className="feature-card">
                        <div className="feature-icon">⏱️</div>
                        <h3>Atendimento Médico</h3>
                        <p>75% dos nossos clientes recebem atendimento médico em até 15 minutos.</p>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Benefits;